import { render, staticRenderFns } from "./archive-campaign-modal.vue?vue&type=template&id=837f042c&"
import script from "./archive-campaign-modal.vue?vue&type=script&lang=js&"
export * from "./archive-campaign-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports